// components/ProtectedLink.js
// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import TokenService from "../../services/token.service";

const ProtectedRoute = ({ children }) => {
  const token = TokenService.getLocalAccessToken();

  // If no token, redirect to no-permission page
  if (!token) {
    return <Navigate to="/no-permission" replace />;
  }

  // If token exists, render the protected component
  return children;
};

export default ProtectedRoute;
